import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChatBubble7: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconChatBubble7"><Path d="M12 20.75C17.1086 20.75 21.25 16.8325 21.25 12C21.25 7.16751 17.1086 3.25 12 3.25C6.89137 3.25 2.75 7.16751 2.75 12C2.75 13.5075 3.15301 14.9259 3.86266 16.1642C4.29953 16.9265 4.56508 17.8078 4.31842 18.651C4.16252 19.184 3.97885 19.7108 3.77778 20.2353C4.63852 20.1821 5.46538 20.0737 6.26982 19.9078C7.03231 19.7506 7.82456 19.8453 8.55228 20.122C9.61775 20.5271 10.7814 20.75 12 20.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconChatBubble7;
